import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { isUserFetching } from "../../../../redux/bridge/selectors";
import { getCurrentLanguage } from "../../../../redux/locale/selectors";
import { selectors as userSelectors } from "../../../../redux/user";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { selectors as routerSelectors } from "../../../../redux/router";
import { actions as modalActions } from "../../../../redux/modals";
import Footer from "../../library/footer";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { studentBannerPadding } from "../../../components/mixins";


const Frame = styled.div`
  ${props => studentBannerPadding(props.showStudentBanner, props.isSmall, props.native)};
`;

function GroupsTab({
  bridgeUserFetching,
  sessionId,
  bridgeUser,
  currentLanguage,
  openRedeemModal,
  native,
  platform,
  enableStudentBanner,
  isSmall
}) {
  if (bridgeUserFetching) {
    // Candy stripe rendering handled outside this component
    return <div />;
  }
  const bridgeUserDetailsForExplore = {
    hasAdmin: bridgeUser.hasAdmin,
    hasGroups: bridgeUser.hasGroups
  };

  const _redeem = () => {
    openRedeemModal();
  }

  return (
    <Frame showStudentBanner={enableStudentBanner} isSmall={isSmall} native={native}>
      <rostering-groups
        isnative={native}
        platform={platform}
        jigsawsessionid={sessionId}
        lang={currentLanguage.short}
        bridgeUser={bridgeUserDetailsForExplore}
      />
      <Footer redeem={() => _redeem()} />
    </Frame>
  );
}

const mapStateToProps = state => {
  return {
    bridgeUserFetching: isUserFetching(state),
    sessionId: userSelectors.getUser(state).sessionId,
    hasAdmin: userSelectors.getUser(state).hasAdmin,
    bridgeUser: bridgeSelectors.getUser(state),
    currentLanguage: getCurrentLanguage(state),
    native: routerSelectors.isNative(state),
    platform: routerSelectors.getQueryParam(state, "platform"),
    brandHasSwimlanes: brandSelectors.brandHasSwimlanes(state),
    enableStudentBanner: brandSelectors.getBrandValue(state, "StudentHome.enabled")
  };
};

const mapDispatchToProps = dispatch => ({
  openRedeemModal: () => dispatch(modalActions.openRedeemModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupsTab);
